<script setup lang="ts">
import type { DataTableRowActionProps } from '@common';
import type { ParcelHeightmapItem } from '../models';
import { toRefs } from 'vue';
import dateFormat from 'date-fns/format';

const props = defineProps<DataTableRowActionProps<any, ParcelHeightmapItem>>();
const { item } = toRefs(props);
</script>

<template>
  <div>
    <v-icon icon="mdi-calendar" />
    <v-tooltip
      activator="parent"
      location="top">
      <div>
        {{
          `${$t('heightmap.label.date')}: ${dateFormat(new Date(item.data.dateFrom), 'yyyy.MM.dd')} - 
            ${dateFormat(new Date(item.data.dateTo), 'yyyy.MM.dd')}
            `
        }}
      </div>
      <div>{{ `${$t('heightmap.label.modem')}: ${item.data.modem || '-'}` }}</div>
    </v-tooltip>
  </div>
</template>
